import React, { useState, useContext, useEffect } from 'react'
import { NavLink, Link, useNavigate} from 'react-router-dom'
import { respuestasContext } from '../contexts/RespuestasContext'



function SessionTypePage({ sesiontypes }) {
  const { respuestas, setRespuestas, addtoanswers } = useContext(respuestasContext);
  const navigate = useNavigate();
  // console.log(sesiontypes[1].route)  

  const manejarClick = (sesiontype) => {
    // Navega a la ruta deseada
    addtoanswers(sesiontype)
    navigate(sesiontype.route);
  };

  return (
    <div className="hero min-h-screen bg-base-200" style={{ backgroundColor: 'lightcoral' }}>
      <div className="hero-content text-center">
        <div className="max-w-md">
          <h1 className="text-2xl font-bold mb-10">Qué tipo de sesión fotográfica desea?</h1>
          <div className="flex flex-col items-center">
            {sesiontypes.map((item) => (
              <button style={{ backgroundColor: 'white', color:'black' }} key={item.sesiontypetitle} className="btn m-5 w-1/2" name={item.sesiontypetitle} onClick={()=> manejarClick(item)}>
                {item.sesiontypetitle}
                </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SessionTypePage